export const PIN_LENGTH = 4;
export const PIN_SPACE_SIZE = 10 ** PIN_LENGTH;
/**
 * Cuántas veces se sortea al azar antes de recurrir a la búsqueda exhaustiva.
 *
 * Con las 4 salas simultáneas que admite la plataforma, la probabilidad de que diez sorteos
 * seguidos caigan en un código ocupado es (4/10000)^10: cero a efectos prácticos. El límite
 * existe solo para que el caso degenerado —el espacio casi lleno— termine siempre.
 */
const RANDOM_ATTEMPTS = 10;
const PIN_PATTERN = /^[0-9]{4}$/;
/**
 * Comprueba que una cadena tiene forma de PIN antes de buscar la sala.
 *
 * Deliberadamente estricto: solo dígitos ASCII, sin espacios, sin signo y sin dígitos de otros
 * sistemas de numeración. `Number.parseInt` aceptaría `' 12a'` y devolvería 12, que es
 * justamente el tipo de indulgencia que convierte una errata en la sala equivocada.
 */
export function isValidPin(candidate) {
    return PIN_PATTERN.test(candidate);
}
/** Convierte un número del espacio de códigos en su representación de cuatro dígitos. */
function toPin(value) {
    return String(value).padStart(PIN_LENGTH, '0');
}
/**
 * Devuelve un PIN libre, o declara que el espacio está agotado.
 *
 * El agotamiento se comunica con un resultado tipado en lugar de una excepción: es un estado
 * previsto del sistema —no quedan salas disponibles— y quien llama debe tratarlo, no ignorarlo.
 *
 * La fuente de aleatoriedad la aporta quien llama, y debe ser uniforme: `crypto.randomInt` lo es.
 * `Math.random()` con módulo introduce un sesgo que haría salir ciertos códigos más a menudo y
 * adelantaría las colisiones respecto a lo que dice la teoría.
 */
export function generatePin(taken, randomInt) {
    for (let attempt = 0; attempt < RANDOM_ATTEMPTS; attempt += 1) {
        const candidate = toPin(randomInt(PIN_SPACE_SIZE));
        if (!taken.has(candidate)) {
            return { ok: true, pin: candidate };
        }
    }
    // Todos los sorteos han chocado: o el espacio está casi lleno, o la fuente de aleatoriedad
    // está fijada por una prueba. Se recorre el espacio y se elige entre lo que queda libre, que
    // encuentra el hueco siempre que exista.
    const free = [];
    for (let value = 0; value < PIN_SPACE_SIZE; value += 1) {
        const candidate = toPin(value);
        if (!taken.has(candidate)) {
            free.push(candidate);
        }
    }
    const chosen = free[randomInt(free.length === 0 ? 1 : free.length)];
    if (chosen === undefined) {
        return { ok: false, reason: 'pin_space_exhausted' };
    }
    return { ok: true, pin: chosen };
}
//# sourceMappingURL=game-pin.js.map